import * as React from 'react'
import { translate } from 'react-translate'
import { includes, toLower, filter } from 'lodash'

const inlineGeneralSelectorStyle = {
  marginLeft: '4px !important',
  marginRight: '4px !important'
}

const metalSpanStyle = {
  textTransform: 'capitalize'
}

class MdProductSelect extends React.Component<any, any> {

  constructor(props: any) {
    super(props)
    this.state = {
      focused: false,
      contracts: this.props.baseContracts.map(c => c.id),
      metals: [],
      products: [],
      selectedProducts: [],
      selectedMetals: [],
      metalSelected: -1
    }

    this.deselectMetal = this.deselectMetal.bind(this)
    this.mouseOverMetal = this.mouseOverMetal.bind(this)
    this.selectAllItems = this.selectAllItems.bind(this)
  }

  public componentWillReceiveProps(nextProps) {
    if (this.props.baseContracts !== nextProps.baseContracts) {
      this.selectAllItems(nextProps.baseContracts)
    }
  }

  public componentWillMount() {
    this.selectAllItems(this.props.baseContracts)
  }

  public isSelectedMetal(metal) {
    return includes(this.state.selectedMetals, metal)
  }

  public isSelectedProduct(product) {
    return includes(this.state.selectedProducts, product)
  }

  public selectMetal(metal, e) {
    e.preventDefault()

    // Map over the potential products
    let newProductsForMetal = window['md3'].product.filter({
      where: {
        id: {
          in: this.props.baseContracts.map(a => a.productId.toString())
        },
        metalId: metal.id
      }
    })

    let newSelectedMetals = (!this.isSelectedMetal(metal))
    ? [...this.state.selectedMetals, metal]
    : this.state.selectedMetals.filter(m => m !== metal)

    let filteredProducts = (!this.isSelectedMetal(metal))
    ? [...this.state.selectedProducts, ...newProductsForMetal]
    : this.state.selectedProducts.filter(p => !includes(newProductsForMetal, p))

    this.setState({
      selectedProducts: filteredProducts,
      selectedMetals: newSelectedMetals,
      contracts: this.determineSelectedContractIds(filteredProducts)
    }, () => {
      this.props.onSelectUpdate({
        metals: this.state.selectedMetals,
        products: this.state.selectedProducts,
        contracts: this.state.contracts
      })
    })
  }

  public selectProduct(product, e) {
    e.preventDefault()
    let newSelectedProducts

    if (!this.isSelectedProduct(product)) {
      newSelectedProducts = [...this.state.selectedProducts, product]
    } else {
      newSelectedProducts = this.state.selectedProducts.filter(p => p !== product)
    }

    let newSelectedMetals = window['md3'].metal.filter({
      where: {
        id: {
          in: newSelectedProducts.map(a => a.metalId.toString())
        }
      }
    })

    this.setState({
      selectedMetals: newSelectedMetals,
      selectedProducts: newSelectedProducts,
      contracts: this.determineSelectedContractIds(newSelectedProducts)
    }, () => {
      this.props.onSelectUpdate({
        metals: this.state.selectedMetals,
        products: this.state.selectedProducts,
        contracts: this.state.contracts
      })
    })
  }

  public selectAllItems(baseContracts) {
    let allMetals = window['md3'].metal.filter({
      where: { id: { in: baseContracts.map(a => a.metalId.toString()) } }
    })
    let allContracts = window['md3'].contract.filter({
      where: { id: { in: baseContracts.map(a => a.id) } }
    })
    let allProductId = window['md3'].product.filter({
      where: { id: { in: baseContracts.map(a => a.productId.toString()) } }
    })

    this.setState({
      contracts: allContracts.map(a => a.id),
      metals: allMetals,
      products: allProductId,
      selectedProducts: allProductId,
      selectedMetals: allMetals
    }, () => {
      this.props.onSelectUpdate({
        metals: this.state.selectedMetals,
        products: this.state.selectedProducts,
        contracts: this.state.contracts
      })
    })
  }

  private determineSelectedContractIds(newProducts) {
    let products = newProducts.length > 0 ?
      newProducts :
      window['md3'].product.filter({
        where: { id: { in: this.props.baseContracts.map(a => a.productId.toString()) } }
      })

    return window['md3'].contract.filter({
      where: {
        id: { in: this.props.baseContracts.map(a => a.id) },
        productId: { in: products.map(a => parseInt(a.id)) }
      }
    }).map(a => a.id)
  }

  public deselectMetal() {
    this.setState({
      metalSelected: -1,
      focused: false
    })
  }

  public mouseOverMetal(metal, e) {
    e.preventDefault()
    this.setState({
      metalSelected: metal.id,
      focused: true
    })
  }

  private focus() {
    this.setState({
      focused: true
    })
  }

  private unfocus() {
    this.setState({
      focused: false,
      metalSelected: -1
    })
  }

  public render() {
    let metalsList = this.state.metals
    let t = this.props.t
    return (
      <div>
        <nav
          className='md-product-select'
          onMouseOver={() => this.focus()}
          onMouseLeave={() => this.unfocus()}
        >

          <div className={'md-product-metals ' + (this.state.focused ? 'active' : '')}>
            <nav className='general-selector' style={inlineGeneralSelectorStyle}>
              <a onClick={this.selectAllItems} onMouseOver={this.deselectMetal} className='active'>{t('ALL_METALS')}</a>
              {metalsList.map((metal, id) => {
                return (
                  <a key={id}
                    onMouseOver={(e) => this.mouseOverMetal(metal, e)}

                    onClick={(e) => this.selectMetal(metal, e)}
                    className={(this.state.metalSelected === metal.id ? 'active' : '')}
                  >
                    <span className={'square-checkbox ' + toLower(metal.name) + (this.isSelectedMetal(metal) ? ' checked' : ' unchecked')}></span>&nbsp;
                    <span className={toLower(metal.name)} style={metalSpanStyle}>{t(metal.name)}</span>
                  </a>
                )
              })}
            </nav>
          </div>
          {metalsList.map((metal, id) => {
            if (this.state.focused && this.state.metalSelected === metal.id) {
              const innerDivStyle = { marginLeft: '4px !important' }

              let productsList = filter(this.state.products, (p: any) => {
                return p.metalId === parseInt(metal.id)
              })

              return (
                <div
                  key={id}
                  className={'md-product-list' + ((this.state.focused && this.state.metalSelected === metal.id) ? ' active' : '')}
                  style={innerDivStyle}>
                  <ul>
                    {productsList.map((product: any, prodId) => {
                      return (<li
                        key={'mdProduct-' + prodId}
                        className='md-product-list-item'
                        onClick={(e) => this.selectProduct(product, e)}>
                        <div
                          className={'square-checkbox ' + toLower(metal.name) + (this.isSelectedProduct(product) ? ' checked' : ' unchecked')}
                        >&nbsp;{t(product.name)}
                        </div>
                      </li>)
                    })}
                  </ul>
                </div>
              )
            }
          })}
        </nav>
      </div>
    )
  }
}

export default translate('MdProductSelect')(MdProductSelect)



// WEBPACK FOOTER //
// ./react/components/widgets/MdProductSelect.tsx